<template>
  <div class="change">
    <footer>
      <div class="inner">
        <section class="contact">
          <p>お問い合わせは下記フォームからお願いいたします。お電話でのお問い合わせも承っております。お気軽にご相談ください。</p>
          <div class="button">
            <!-- <a href="javascript:void(p);" id="btn_contact">お問い合わせ</a> -->
            <a style="border: none"/>
            <a href="javascript:void(p);" id="btn_tel">
              <picture>
                <source :srcset="getImage('footer/btn_tel_footer.png')" type="image/png" media="(min-width: 700px)">
                <img :src="getImage('footer/btn_tel_footer.png')" type="image/png" alt="電話">
              </picture>
            </a>
            <a style="border: none"/>
            <!-- <a href="javascript:void(p);" id="btn_faq">よくある質問</a> -->
          </div>
        </section>
        <section class="sitemap">
          <div class="logo_space">
            <div class="mm_logo">
              <!-- <a class="instagram" href="index.html">
                <picture>
                  <source :srcset="getImage('header/mm_logo_header_w.png')" type="image/png" media="(min-width: 700px)">
                  <img :src="getImage('header/mm_logo_header_w.png')" type="image/png" alt="SKETCH ORDER">
                </picture>
              </a> -->
            </div>
            <div class="sns_icon">
              <a class="instagram" href="/">
                <picture>
                  <source :srcset="getImage('footer/Instagram_Glyph_White_360.png')" type="image/png" media="(min-width: 700px)">
                  <img :src="getImage('footer/Instagram_Glyph_White_360.png')" type="image/png" alt="Instagram">
                </picture>
              </a>
              <a class="facebook" href="/">
                <picture>
                  <source :srcset="getImage('footer/f_logo_RGB-White_250.png')" type="image/png" media="(min-width: 700px)">
                  <img :src="getImage('footer/f_logo_RGB-White_250.png')" type="image/png" alt="facebook">
                </picture>
              </a>
            </div>
          </div>
          <div class="menu_space">
            <!-- <ul>
              <li><a href="index.html">購入ガイド</a></li>
              <li><a href="index.html">カートを見る</a></li>
              <li><a href="index.html">お問い合わせ</a></li>
              <li><a href="index.html">よくある質問</a></li>
              <li><a href="index.html">利用規約</a></li>
            </ul>
            <ul>
              <li><a href="index.html">mm/styleカタログ</a></li>
              <li><a href="index.html">打合せ依頼</a></li>
            </ul>
            <ul>
              <li><a href="index.html">会社案内</a></li>
              <li><a href="index.html">プライバシーポリシー</a></li>
              <li><a href="index.html">特定商取引法の表示</a></li>
            </ul> -->
          </div>
        </section>
        <section class="copyright">
          <p>Copyright ©2024 domans all rights reserved.</p>
        </section>
      </div>
    </footer>
  </div>
</template>
<script>
import * as App from '../utils/App'

export default {
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    getImage: function (image) {
      return App.getSketchResource(image)
    }
  },
  mounted () {
  },
  created: function () {
  }
}
</script>
<style src="../css/footer.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/main/js/components/Footer.vue